/* eslint-disable react-hooks/exhaustive-deps */
import { API, I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { Chip, TextField, MenuItem, Box, IconButton, Menu, Button } from '@material-ui/core';
import { FUNCTION_SETTING, BASIC_SETTING, ADVANCED_SETTING } from '@/common/constant/ModuleSettingVersionConstant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import {
    filterLabelByKey,
    validateTextField,
    editModelSetting,
    handleAddNew,
    handleOnBlurEditSystemPromptModelSetting,
    onDeleteAddModelSetting,
    onDeleteModelSetting,
    handleModelChange
} from '../../../handler/VersionListHandler';
import Utils from '@/common/utils/utils';
import { HelperText } from '@/component/common/form/input';
import OverFlowTooltipWithCustomCss from '@/component/common/OverFlowTooltipWithCustomCss';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { checkModelUnsupport } from '@/component/system/handler/OrganizationProfileHandler';
import Constant from '@/common/constant/Constant';

import { v4 as uuidv4 } from 'uuid';
import AddModelSettingRow from './AddModelSettingRow';

import { PropTypes } from 'prop-types';
FunctionSetting.propTypes = {
    value: PropTypes.any,

    chatGPTModelList: PropTypes.any,

    modelSettingList: PropTypes.any,
    setModelSettingList: PropTypes.any,
    modelSettingAddList: PropTypes.any,
    setModelSettingAddList: PropTypes.any,
    modelSettingListRoot: PropTypes.any,
    setModelSettingListRoot: PropTypes.any,

    setIsOpenModalReloadPage: PropTypes.any,
};
function FunctionSetting({
    value,
    setValue,
    setBasicSettingValue,
    setAdvancedSettingValue,
    setIsEdit,
    lincenseKey,
    setLincenseKey,
    setIsChangeLincenseKey,
    isRootSetting,
    setBasicAIPrompt,
    setIsLoading,
    basicAIPrompt,
    systemPrompt,
    setSystemPrompt,
    setIsChangeSystemPrompt,
    defaultSystemPrompt,

    chatGPTModel,
    setChatGPTModel,
    chatGPTModelList,
    knn,
    setKnn,
    minScore,
    setMinScore,
    chatGPTModelDefault,
    knnDefault,
    minScoreDefault,
    inputSystemPrompt,
    setInputSystemPrompt,

    interatorSystemPrompt,
    setInteratorSystemPrompt,
    setIsChangeInteratorSystemPrompt,
    defaultInteratorSystemPrompt,
    inputInteratorSystemPrompt,
    setInputInteratorSystemPrompt,

    modelSettingList,
    setModelSettingList,
    modelSettingAddList,
    setModelSettingAddList,
    modelSettingListRoot,
    setModelSettingListRoot,
    ...props
}) {
    const licenseKeyDefault = {...props}.licenseKeyDefault;
    let addNewPanel = useSetRecoilState(setPanelSelector);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    let isErrorModelGpt = checkModelUnsupport(chatGPTModel, chatGPTModelList);
    const [selectedMenuIndex, setSelectedMenuIndex] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event, index) => {
        setAnchorEl(event.currentTarget);
        setSelectedMenuIndex(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedMenuIndex(null);
    };

    const handleChangeFunctionSettingValue = (field, option, parent) => {
        switch (field) {
            case 'internalQACounterSettings':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setBasicSettingValue(item => {
                    return {
                        ...item,
                        numberOfQACounters: BASIC_SETTING.numberOfQACounters
                    };
                });
                setAdvancedSettingValue(item => {
                    return {
                        ...item,
                        numberOfAdditionalQACounter: ADVANCED_SETTING.numberOfAdditionalQACounter
                    };
                });
                break;
            case 'deskService':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        internalQACounterSettings: {
                            ...item.internalQACounterSettings,
                            value: !option.value
                        },
                        [parent]: {
                            group: {
                                ...item[parent].group,
                                [field]: {
                                    ...item[parent].group[field],
                                    value: !option.value
                                }
                            }
                        }
                    };
                });
                setBasicSettingValue(item => {
                    return {
                        ...item,
                        numberOfQACounters: BASIC_SETTING.numberOfQACounters,
                        numberOfSupportedCounters: BASIC_SETTING.numberOfSupportedCounters,
                        numberOfB2C: BASIC_SETTING.numberOfB2C
                    };
                });
                setAdvancedSettingValue(item => {
                    return {
                        ...item,
                        numberOfAdditionalQACounter: ADVANCED_SETTING.numberOfAdditionalQACounter,
                        numberOfAdditionalSupportedCounter:
                            ADVANCED_SETTING.numberOfAdditionalSupportedCounter
                    };
                });
                break;
            case 'knowledgeService':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [parent]: {
                            group: {
                                ...item[parent].group,
                                [field]: {
                                    ...item[parent].group[field],
                                    value: !option.value
                                }
                            }
                        }
                    };
                });
                setBasicSettingValue(item => {
                    return {
                        ...item,
                        numberOfKnowledges: BASIC_SETTING.numberOfKnowledges
                    };
                });
                setAdvancedSettingValue(item => {
                    return {
                        ...item,
                        numberOfAdditionalKnowledge: ADVANCED_SETTING.numberOfAdditionalKnowledge
                    };
                });
                break;
            case 'publicWebForm':
            case 'publicService':
            case 'knowledgeBot':
            case 'synonymSearch':
            case 'convertPDF':
            case 'batchCommandService':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [parent]: {
                            group: {
                                ...item[parent].group,
                                [field]: {
                                    ...item[parent].group[field],
                                    value: !option.value
                                }
                            }
                        }
                    };
                });
                break;
            case 'advancedOptionSettings':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setAdvancedSettingValue(ADVANCED_SETTING);
                break;
            case 'chatAI':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        },
                        lincenseKeyPermission: {
                            value: option.value ? false : item.lincenseKeyPermission.value
                        },
                        aiAuto: {
                            value: option.value ? false : item.aiAuto.value
                        },
                        sdAuto: {
                            value: option.value ? false : item.sdAuto.value
                        },
                        telephoneAgent: {
                            value: option.value ? false : item.telephoneAgent.value
                        },
                        mcpServer: {
                            value: option.value ? false : item.mcpServer.value
                        },
                    };
                });
                setSystemPrompt(defaultSystemPrompt);
                setInteratorSystemPrompt(defaultInteratorSystemPrompt);
                setChatGPTModel(chatGPTModelDefault);
                setKnn(knnDefault);
                setMinScore(minScoreDefault);
                // setLincenseKey(prev => ({
                //     ...prev,
                //     error: '',
                //     value: licenseKeyDefault 
                // }));
                setModelSettingList(modelSettingListRoot);
                setModelSettingAddList([]);
                break;
            case 'lincenseKeyPermission':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });

                // https://new.redmine.ominext.com/issues/253013
                // When turn off license key permission, set value to license key default: option.value is current value
                if (option.value) {
                    setLincenseKey(prev => ({
                        ...prev,
                        error: '',
                        value: licenseKeyDefault
                    }));
                }
                break;
            case 'aiAuto':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setSystemPrompt(defaultSystemPrompt);
                setInteratorSystemPrompt(defaultInteratorSystemPrompt);
                setModelSettingList(modelSettingListRoot);
                setModelSettingAddList([]);
                break;
            case Constant.SETTING_VERSION_LABEL.TELEPHONE_AGENT:
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                break;
            // case Constant.SETTING_VERSION_LABEL.EXTERNAL_WEB_API:
            default:
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                break;
        }
    };

    const handleDisabled = item => {
        switch (item) {
            case 'publicWebForm':
                return !value.externalServiceDeskSettings.group.deskService.value;
            case 'publicService':
            case 'knowledgeBot':
            case 'synonymSearch':
            case 'convertPDF':
            case 'batchCommandService':
                return !value.knowledgeFunction.group.knowledgeService.value;
            case 'lincenseKeyPermission':
            case 'aiAuto':
            case Constant.SETTING_VERSION_LABEL.TELEPHONE_AGENT:
            case 'sdAuto':
            case 'mcpServer':
                return !value.chatAI.value;
            default:
                return false;
        }
    };

    const handleChangeInputLincenseKey = (e) => {
        let lincenseKeyValue = e.target.value.trim();
        setIsEdit(true);
        setIsChangeLincenseKey(true);
        setLincenseKey(prev => ({
            ...prev,
            value: lincenseKeyValue,
            error: ''
        }))
    };

    const handleDisableLincenseKeyInput = () => {
        return !value.chatAI.value || !value.lincenseKeyPermission.value;
    };

    const handleDisableSystemPromptInput = () => {
        return !value.chatAI.value || !value.aiAuto.value;
    };

    useEffect(() => {
        if (!value.externalServiceDeskSettings.group.deskService.value) {
            setValue(prev => {
                return {
                    ...prev,
                    externalServiceDeskSettings: { ...FUNCTION_SETTING.externalServiceDeskSettings }
                };
            });
        }

        if (!value.knowledgeFunction.group.knowledgeService.value) {
            setValue(prev => {
                return {
                    ...prev,
                    knowledgeFunction:  { ...FUNCTION_SETTING.knowledgeFunction }
                };
            });
        }
    }, [
        value.externalServiceDeskSettings.group.deskService.value,
        value.knowledgeFunction.group.knowledgeService.value,
    ]);

    const renderSystemPrompt = (
        systemPromptData,
        setIsChangeSystemPromptData,
        item,
        fieldKey
    ) => {
        return (
            <div className={`prompt-basic-chip-ai-auto class-system-prompt prompt-basic-chip-ai-auto-column`}>
                {!systemPromptData?.value ||
                (systemPromptData?.value && systemPromptData?.error) ? (
                    <>
                        <TextField
                            className="form-control-input form-control-wrapInput form-control-hg32 input-basic-chip"
                            variant="outlined"
                            spellCheck={false}
                            autoComplete="seriously-please-don't-autocomplete"
                            type="text"
                            onBlur={async e => {
                                let params = {
                                    e: e,
                                    API: API,
                                    setIsLoading: setIsLoading,
                                    systemPromptData: systemPromptData,
                                    setIsEdited: setIsEdit,
                                    setIsChangeSystemPromptData: setIsChangeSystemPromptData,
                                    setModelSettingAddList: setModelSettingList,
                                    currentIndex: item.id,
                                    fieldKey: fieldKey
                                };
                                await handleOnBlurEditSystemPromptModelSetting(params);
                            }}
                            helperText={''}
                            error={!Utils.isEmptyString(systemPromptData.error)}
                            disabled={handleDisableSystemPromptInput() || isDisableChangeEdit(item)}
                            value={systemPromptData?.linkPrompt}
                            onChange={e => {
                                handleEditTextField(e, item.id, fieldKey, item);
                            }}
                        />
                        {!Utils.isEmptyString(systemPromptData?.error) && (
                            <div>
                                <span className="text-warning-chat-ai text-warning-model">
                                    {I18n.get(systemPromptData?.error)}
                                </span>
                            </div>
                        )}
                    </>
                ) : (
                    <Chip
                        label={
                            <OverFlowTooltipWithCustomCss
                                value={systemPromptData?.value}
                                placement={'top'}
                            />
                        }
                        onClick={async () => {
                            if (Utils.isEmptyString(systemPromptData?.value)) return;
                            const idTicket = await Utils.getTicketIdByShareLink(
                                systemPromptData?.linkPrompt
                            );
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                idTicket,
                                projectInuseDetail,
                                props.setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        onDelete={isDisableChangeEdit(item) ? null : (e) => handleDeleteModelField(item, fieldKey, setIsChangeSystemPromptData)}
                        disableRipple={handleDisableSystemPromptInput() || isDisableChangeEdit(item)}
                        deleteIcon={isDisableChangeEdit(item) ? null : (
                            <img
                                className={`basic-chip-delete-icon ${
                                    handleDisableSystemPromptInput()
                                        ? 'basic-chip-delete-icon-disable'
                                        : ''
                                }`}
                                src="/assets/image/delete-icon-rounded.svg"
                                alt="delete"
                            />
                        )}
                        className={`basic-chip chip-ai-auto top-4px ${
                            handleDisableSystemPromptInput() ? 'basic-chip-disable' : ''
                        }`}
                    />
                )}
            </div>
        );
    };


    const isDisableAISetting = () => {
        return !value.chatAI.value;
    }

    const handleChangeInputKnn = (e) => {
        let knnValueInput = e.target.value;
        setIsEdit(true);
        setKnn(pre => ({...pre, value: knnValueInput, error: ''}));
    };

    // const handleKeyDownInputKnn = (event) => {
    //     if (['-', '.', 'e'].includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    const handleOnBlurInputKnn = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 10000},
            {name: 'minValue', value: 1},  
            {name: 'isRequire'},
            {name: 'isNumber'},
        ]
        let fieldKey = 'knn'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setKnn(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }

    const handleChangeInputMinScore = (e) => {
        let minScoreInput = e.target.value;
        if (minScoreInput.includes(".")) {
            const [integerPart, decimalPart] = minScoreInput.split(".");

            if (decimalPart && decimalPart.length > 2) {
                return;
            }
        }

        setIsEdit(true);
        setMinScore((pre) => ({ ...pre, value: minScoreInput, error: "" }));
    };

    // const handleKeyDownInputMinScore = (event) => {
    //     if (['-', 'e', '+', ','].includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    const handleOnBlurInputMinScore = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 1},
            {name: 'minValue', value: 0},
            {name: 'isRequire'},
            {name: 'isDecimal'},
        ]
        let fieldKey = 'minScore'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setMinScore(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }

    // render tbl model setting list
    const renderTblModelSettingList = () => {
        let listItems = modelSettingList.map((item, i) => {
            const isLastRow = i === modelSettingList.length - 1;
            const modelErrorMessage = [
                {
                    condition: checkModelUnsupport(item?.model, chatGPTModelList),
                    message: I18n.get('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER, item.model),
                },
                {
                    condition: item.hasDuplicate,
                    message: I18n.get('MSG_AI_MODEL_DUPLICATE'),
                },
            ].find(err => err.condition)?.message;
            return (
                <div key={item.id} className={`model-setting-item-common${isLastRow ? ' model-setting-last-item' : ''}`}>
                    {/* CHATGPT_MODEL */}
                    <div className="model-setting-item">
                        <label className="setting-label">
                            {I18n.get('ORG-INFOR-LABEL-CHATGPT-MODEL')}
                        </label>
                        <div>
                            {/* hamburger icon */}
                            <IconButton
                                className="close more-model-setting"
                                aria-label="more"
                                id={`long-button-hamburger-${i}`}
                                aria-controls={'long-menu'}
                                aria-expanded={'true'}
                                aria-haspopup="true"
                                onClick={(e) => handleClick(e, i)}
                                disabled={handleDisableSystemPromptInput()}
                            >
                                <img
                                    src="/assets/image/icon-hamburger.svg"
                                    alt="Icon hamburger"
                                />
                            </IconButton>
                            <Menu
                                id={`long-menu-hamburger-${i}`}
                                className="view-mode-group-btn"
                                anchorEl={anchorEl}
                                open={selectedMenuIndex === i}
                                onClose={handleClose}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                MenuListProps={{
                                    className: 'view-mode-group-btn-hamburger'
                                }}
                                PaperProps={{
                                    style: {
                                        minWidth: '160px',
                                        minHeight: '40px'
                                    }
                                }}
                            >
                                <div className="hamburger-list">
                                    {/* Edit Model Setting */}
                                    <Box
                                        className="hamburger-item"
                                        key={`edit-${item.id}`}
                                        onClick={() => {
                                            let argParams = {
                                                modelSettingList,
                                                setModelSettingList,
                                                setIsEdited: setIsEdit
                                            }
                                            editModelSetting(i, item, argParams);
                                            handleClose();
                                        }}
                                    >
                                        <IconButton className="itemNav">
                                            <img src="/assets/image/edit-icon.svg" alt="" />
                                        </IconButton>
                                        {I18n.get('HAMBURGER-EDIT')}
                                    </Box>

                                    {/* Delete Model Setting */}
                                    <Box
                                        className="hamburger-item"
                                        onClick={() => {
                                            let dataDelete = {
                                                model: item,
                                                modelSettingAddList,
                                                modelSettingList,
                                                setModelSettingAddList,
                                                setModelSettingList,
                                                setIsEdit
                                            }
                                            onDeleteModelSetting(dataDelete);
                                            handleClose();
                                        }}
                                    >
                                        <IconButton className="itemNav">
                                            <img
                                                src="/assets/image/icon-tabs-delete.svg"
                                                alt=""
                                            />
                                        </IconButton>
                                        {I18n.get('HAMBURGER-DELETE')}
                                    </Box>
                                </div>
                            </Menu>
                        </div>
                    </div>

                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 width-80 chatGPT-model"
                        select
                        disabled={handleDisableSystemPromptInput() || isDisableChangeEdit(item)}
                        variant="outlined"
                        name="selectedChatGPTModel"
                        value={`${item.model}`}
                        defaultValue={`${item.model}`}
                        SelectProps={{
                            value: `${item.model}`,
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        onChange={e => {
                            let  dataChange = {
                                itemId: item.id,
                                newModel: e.target.value,
                                modelSettingAddList,
                                setModelSettingAddList,
                                modelSettingList,
                                setModelSettingList,
                                chatGPTModelList,
                                setIsEdit
                            };
                            handleModelChange(dataChange)
                        }}
                        error={modelErrorMessage}
                    >
                        {chatGPTModelList.map(chatGPT => {
                            return (
                                <MenuItem
                                    key={`chatGPT-${chatGPT.id}`}
                                    value={chatGPT.id}
                                    className={
                                        chatGPT?.status ===
                                            Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT && 'd-hidden'
                                    }
                                >
                                    <OverFlowTooltipWithTabsMui
                                        className={`className-${chatGPT.id}`}
                                        value={chatGPT.id}
                                    >
                                        {chatGPT.id}
                                    </OverFlowTooltipWithTabsMui>
                                </MenuItem>
                            );
                        })}
                    </TextField>
                    {modelErrorMessage && (
                        <div>
                            <span className='text-warning-chat-ai text-warning-model'>
                                {modelErrorMessage}
                            </span>
                        </div>
                    )}
                    {/* SYSTEM PROMPT */}
                    <div className="model-setting-item model-setting-item-prompt">
                        <label className="setting-label">
                            {ProductManagementConstant.TEXTBOX_SETTING_SYSTEM_PROMPT}
                        </label>
                    </div>
                    {renderSystemPrompt(
                        item.systemPrompt,
                        setIsChangeSystemPrompt,
                        item,
                        Constant.MODEL_PROMPT_TYPE.SYSTEM_PROMPT
                    )}

                    {/* INTERATORSYSTEM PROMPT */}
                    {/* <div className="model-setting-item model-setting-item-prompt">
                        <label className="setting-label">
                            {ProductManagementConstant.TEXTBOX_SETTING_INTERATOR_SYSTEM_PROMPT}
                        </label>
                    </div>
                    {renderSystemPrompt(
                        item.interatorSystemPrompt,
                        setIsChangeInteratorSystemPrompt,
                        item,
                        Constant.MODEL_PROMPT_TYPE.INTERATOR_SYSTEM_PROMPT
                    )} */}
                </div>
            );
        });

        let tbl = (
            <div className="group-model-setting-version">
                <div>{renderFormAddModelSetting()}</div>
                <div>{listItems}</div>
            </div>
        );
        return Utils.isEmptyArray(modelSettingList) && Utils.isEmptyArray(modelSettingAddList) ? (
            <></>
        ) : (
            tbl
        );
    };

    // render form add new model setting
    const renderFormAddModelSetting = () => {
        let listItemsAdd = modelSettingAddList.map((item, i) => (
            <AddModelSettingRow
                key={item.id || uuidv4()}
                currentAddList={modelSettingAddList}
                modelSettingList={modelSettingList}
                currentIndex={item.id}
                usingChatAI={value.chatAI.value}
                usingAIAuto={value.aiAuto.value}
                setIsLoading={setIsLoading}
                setIsEdited={setIsEdit}
                setIsOpenModalReloadPage={props.setIsOpenModalReloadPage}
                addNewPanel={addNewPanel}
                chatGPTModelList={chatGPTModelList}
                onDeleteModelSetting={() => {
                    let dataDelete = {
                        model: item,
                        modelSettingAddList,
                        modelSettingList,
                        setModelSettingAddList,
                        setModelSettingList,
                        setIsEdit
                    }
                    onDeleteAddModelSetting(dataDelete)
                }}
                modelSettingDetail={item}
                setModelSettingAddList={setModelSettingAddList}
                setModelSettingList={setModelSettingList}
                setIsOpenAccessDeniedPopup={setIsOpenAccessDeniedPopup}
            />
        ));

        return listItemsAdd;
    };

    const isDisableChangeEdit = (model) => {
        let result = (typeof model?.editing === "undefined" || model?.editing == 0);
        return result;
    };

    const handleEditTextField = (e, id, fieldKey, item) => {
        let inputValue = e.target.value;

        switch (fieldKey) {
            case Constant.MODEL_PROMPT_TYPE.INTERATOR_SYSTEM_PROMPT:
            case Constant.MODEL_PROMPT_TYPE.SYSTEM_PROMPT:
                setModelSettingList(prevList => {
                    const updatedList = prevList.map(model => {
                        if (model.id === id) {
                            return {
                                ...model,
                                [fieldKey]: {
                                    ...model[fieldKey],
                                    linkPrompt: inputValue,
                                },
                                hasChange: true,
                            };
                        }
                        return model; 
                    });
                    return updatedList;
                });
                break;
        
            default:
                return;
        }
    }

    const handleDeleteModelField = (item, fieldKey, setIsChangeSystemPromptData) => {
        if (handleDisableSystemPromptInput()) return;
        if (isDisableChangeEdit(item)) return;

        setModelSettingList(prevList =>
            prevList.map(model => resetModelField(model, item, fieldKey))
        );

        setIsEdit(true);
        setIsChangeSystemPromptData(true);
    };

    const resetModelField = (model, item, fieldKey) => {
        if (model.id !== item.id) return model;
        return {
            ...model,
            [fieldKey]: {
                ...model[fieldKey],
                error: '',
                value: '',
                linkPrompt: ''
            },
            hasChange: true,
        };
    };

    return (
        <>
            <div className="setting-description border-bottom">
                <span className="description-detail">機能名</span>
                <span className="description-detail">有効/無効</span>
            </div>
            {Object.entries(value).filter(item => !["internalQACounterSettings", "taskManagement"].includes(item[0])).map((item, index) => {
                if (!item[1].group) {
                    switch (item[0]) {
                        case 'chatAI':
                            return (
                                <div className={`setting-item chatAI-item`} key={index}>
                                    <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id={`switch-${item[0]}-mode`}
                                            checked={item[1].value}
                                            value={item[1].value}
                                            onChange={() =>
                                                handleChangeFunctionSettingValue(item[0], item[1])
                                            }
                                        />
                                        <label htmlFor={`switch-${item[0]}-mode`}></label>
                                    </div>
                                </div>
                            );
                        case 'lincenseKeyPermission':
                            return (
                                <>
                                    {/* {value.chatAI.value && ( */}
                                        <div className='setting-item-ai-key lincenseKey' key={index}>
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                                <div className="switch-check">
                                                    <input
                                                        type="checkbox"
                                                        id={`switch-${item[0]}-mode`}
                                                        checked={item[1].value}
                                                        disabled={handleDisabled(item[0])}
                                                        value={item[1].value}
                                                        onChange={() =>
                                                            handleChangeFunctionSettingValue(item[0], item[1])
                                                        }
                                                    />
                                                    <label htmlFor={`switch-${item[0]}-mode`}></label>
                                                </div>
                                            </div>
                                            {false && (
                                                <div className="setting-children-item">
                                                    <HelperText
                                                        error
                                                        text={I18n.get('LABEL-MSG-NOTI-LICENSE-AI')}
                                                        classes='helper-lincenseKey'
                                                    />
                                                </div>
                                            )}
                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{ProductManagementConstant.TEXTBOX_SETTING_LINCENSE_KEY}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                <TextField
                                                    className="form-control-input form-control-wrapInput form-control-hg32 lincenseKey-input-version"
                                                    variant="outlined"
                                                    spellCheck={false}
                                                    type='text'
                                                    value={lincenseKey.value}
                                                    disabled={handleDisableLincenseKeyInput()}
                                                    onChange={e => handleChangeInputLincenseKey(e)}
                                                    onBlur={e => {
                                                        const newValue = e.target.value.trim();
                                                        if (Utils.isEmptyString(newValue)) {
                                                            // When input empty, clear error and mark as changed
                                                            setLincenseKey(prev => ({
                                                                ...prev,
                                                                error: '', // Clear error when empty
                                                                value: ''
                                                            }));
                                                            setIsChangeLincenseKey(true);
                                                        } else {
                                                            // Only validate when has value and permission is ON
                                                            if (!value?.lincenseKeyPermission?.value) {
                                                                setLincenseKey(prev => ({
                                                                    ...prev,
                                                                    error: I18n.get('COMMSG014')
                                                                }));
                                                            } else {
                                                                setLincenseKey(prev => ({
                                                                    ...prev,
                                                                    error: ''
                                                                }));
                                                            }
                                                        }
                                                    }}
                                                    onWheel={e => e.target.blur()}
                                                    helperText={lincenseKey.error}
                                                    error={!Utils.isEmptyString(lincenseKey.error)}
                                                />
                                            </div>

                                             {/* CHATGPT_MODEL */}
                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{I18n.get('ORG-INFOR-LABEL-CHATGPT-MODEL')}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                 <TextField
                                                    // className="form-control form-control--wrap form-control--hg40 width-70"
                                                    className="form-control-input form-control-wrapInput form-control-hg32 width-70 chatGPT-model"
                                                    select
                                                    disabled={isDisableAISetting()}
                                                    variant="outlined"
                                                    name="selectedChatGPTModel"
                                                    value={`${chatGPTModel}`}
                                                    defaultValue={`${chatGPTModel}`}
                                                    SelectProps={{
                                                        value: `${chatGPTModel}`,
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: 'bottom',
                                                                horizontal: 'left'
                                                            },
                                                            getContentAnchorEl: null,
                                                            className: 'selectDrop'
                                                        }
                                                    }}
                                                    onChange={e => {
                                                        setChatGPTModel(e.target.value);
                                                        setIsEdit(true);
                                                    }}
                                                    helperText={isErrorModelGpt ? I18n.get('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER, chatGPTModel) : ''}
                                                    error={isErrorModelGpt}
                                                >
                                                    {chatGPTModelList.map(chatGPT => {
                                                        return (
                                                            <MenuItem
                                                                key={`chatGPT-${chatGPT.id}`}
                                                                value={chatGPT.id}
                                                                className={chatGPT?.status === Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT && "d-hidden"}
                                                            >
                                                                <OverFlowTooltipWithTabsMui
                                                                    className={`className-${chatGPT.id}`}
                                                                    value={chatGPT.id}
                                                                >
                                                                    {chatGPT.id}
                                                                </OverFlowTooltipWithTabsMui>
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </TextField>
                                            </div>

                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{I18n.get('ORG-INFOR-LABEL-KNN-VALUE')}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                <TextField
                                                    name="knnValue"
                                                    className="form-control-input form-control-wrapInput form-control-hg32 edit-org-input width-70"
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    value={knn.value}
                                                    onChange={e => handleChangeInputKnn(e)}
                                                    onBlur={e => handleOnBlurInputKnn(e)}
                                                    // onKeyDown={e => handleKeyDownInputKnn(e)}
                                                    disabled={isDisableAISetting()}
                                                    type='text'
                                                    helperText={knn.error}
                                                    error={!Utils.isEmptyString(knn.error)}
                                                />
                                            </div>

                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{I18n.get('ORG-INFOR-LABEL-MIN-SCORE')}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                <TextField
                                                    name="minScore"
                                                    className="form-control-input form-control-wrapInput form-control-hg32 edit-org-input width-70"
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    value={minScore.value}
                                                    onChange={e => handleChangeInputMinScore(e)}
                                                    onBlur={e => handleOnBlurInputMinScore(e)}
                                                    // onKeyDown={e => handleKeyDownInputMinScore(e)}
                                                    disabled={isDisableAISetting()}
                                                    type='text'
                                                    helperText={minScore.error}
                                                    error={!Utils.isEmptyString(minScore.error)}
                                                />
                                            </div>
                                            
                                        </div>
                                    {/* )} */}
                                </>
                            );
                            
                        case 'aiAuto':
                            return (
                                <div className='setting-item-ai-auto lincenseKey' key={index}>
                                    <div className="setting-children-item lincenseKeyPermission-item">
                                        <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                        <div className="switch-check">
                                            <input
                                                type="checkbox"
                                                id={`switch-${item[0]}-mode`}
                                                checked={item[1].value}
                                                disabled={handleDisabled(item[0])}
                                                value={item[1].value}
                                                onChange={() =>
                                                    handleChangeFunctionSettingValue(item[0], item[1])
                                                }
                                            />
                                            <label htmlFor={`switch-${item[0]}-mode`}></label>
                                        </div>
                                    </div>
                                    {false && (
                                        <div className="setting-children-item helper-text">
                                            <HelperText
                                                error
                                                text={I18n.get('LABEL-MSG-NOTI-LICENSE-AI')}
                                                classes='helper-lincenseKey'
                                            />
                                        </div>
                                    )}
                                    {/* Header Add */}
                                    <div style={{display: 'flex'}}>
                                        <div className="setting-children-item line-stream"></div>
                                        <div className="head-btn head-btn-version">
                                            <div className="head-btn-add">
                                                <Button 
                                                    className="btn-add-model-setting" 
                                                    onClick={e => {
                                                        handleAddNew(modelSettingAddList, setModelSettingAddList);
                                                        setIsEdit(true);
                                                    }}
                                                    disabled={handleDisableSystemPromptInput()}
                                                >
                                                    <div className="btn-plus-icon">
                                                        <img src={
                                                            handleDisableSystemPromptInput()
                                                                ? '/assets/image/icon-plus-accordion.svg'
                                                                : '/assets/image/icon-plus-add.svg'
                                                            }
                                                            alt="" 
                                                        />
                                                    </div>
                                                    <div className="btn-text-add">{I18n.get('ORG-INFOR-LABEL-ADD-AI-MODEL-SETTING')}</div>
                                                </Button>
                                            </div>
                                        </div>                     
                                    </div>
                                    
                                    <div style={{display: 'flex'}}>
                                        <div className={`setting-children-item line-stream ${Utils.isEmptyArray(modelSettingList) && Utils.isEmptyArray(modelSettingAddList) ? 'padding-0px' : ''}`}></div>
                                        <div className={`model-setting-version`}>{renderTblModelSettingList()}</div>
                                    </div>
                                </div>
                            );
                        case 'sdAuto':
                        case Constant.SETTING_VERSION_LABEL.TELEPHONE_AGENT:
                            return (
                                <div className='setting-item-ai-auto lincenseKey' key={index}>
                                    <div className="setting-children-item lincenseKeyPermission-item">
                                        <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                        <div className="switch-check">
                                            <input
                                                type="checkbox"
                                                id={`switch-${item[0]}-mode`}
                                                checked={item[1].value}
                                                disabled={handleDisabled(item[0])}
                                                value={item[1].value}
                                                onChange={() =>
                                                    handleChangeFunctionSettingValue(item[0], item[1])
                                                }
                                            />
                                            <label htmlFor={`switch-${item[0]}-mode`}></label>
                                        </div>
                                    </div>
                                    <div className="line-stream"></div>
                                </div>
                            );
                        case Constant.SETTING_VERSION_LABEL.EXTERNAL_WEB_API:
                            return (
                                <></>
                                // <>
                                //     <div className='setting-item-ai-auto border-bottom lincenseKey' key={index}>
                                //         <div className="setting-children-item lincenseKeyPermission-item">
                                //             <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                //             <div className="switch-check">
                                //                 <input
                                //                     type="checkbox"
                                //                     id={`switch-${item[0]}-mode`}
                                //                     checked={item[1].value}
                                //                     disabled={handleDisabled(item[0])}
                                //                     value={item[1].value}
                                //                     onChange={() =>
                                //                         handleChangeFunctionSettingValue(item[0], item[1])
                                //                     }
                                //                 />
                                //                 <label htmlFor={`switch-${item[0]}-mode`} className='hide-text-label'>{filterLabelByKey(item[0])}</label>
                                //             </div>
                                //         </div>
                                //     </div>
                                // </>
                            );
                        case Constant.SETTING_VERSION_LABEL.MCP_SERVER:
                            return (
                                <>
                                    <div className='setting-item-ai-auto border-bottom lincenseKey' key={index}>
                                        <div className="setting-children-item lincenseKeyPermission-item">
                                            <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                            <div className="switch-check">
                                                <input
                                                    type="checkbox"
                                                    id={`switch-${item[0]}-mode`}
                                                    checked={item[1].value}
                                                    disabled={handleDisabled(item[0])}
                                                    value={item[1].value}
                                                    onChange={() =>
                                                        handleChangeFunctionSettingValue(item[0], item[1])
                                                    }
                                                />
                                                <label htmlFor={`switch-${item[0]}-mode`} className='hide-text-label'>{filterLabelByKey(item[0])}</label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            );
                        default:
                            return (
                                <div className="setting-item border-bottom" key={index}>
                                    <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id={`switch-${item[0]}-mode`}
                                            checked={item[1].value}
                                            value={item[1].value}
                                            onChange={() =>
                                                handleChangeFunctionSettingValue(item[0], item[1])
                                            }
                                        />
                                        <label htmlFor={`switch-${item[0]}-mode`}></label>
                                    </div>
                                </div>
                            );
                    }
                } else {
                    return (
                        <div className="setting-item setting-item-group border-bottom" key={index}>
                            <label className="setting-label">{filterLabelByKey(item[0])}</label>
                            {Object.entries(item[1].group).map((groupItem, i) => {
                                return (
                                    <>
                                        <div
                                            className={`setting-children-item`}
                                            data-group={groupItem[0]}
                                            key={i}
                                        >
                                            <label className="setting-label">
                                                {filterLabelByKey(groupItem[0])}
                                            </label>
                                            <div className="switch-check">
                                                <input
                                                    type="checkbox"
                                                    id={`switch-${groupItem[0]}-mode`}
                                                    checked={groupItem[1].value}
                                                    disabled={handleDisabled(groupItem[0])}
                                                    value={groupItem[1].value}
                                                    onChange={() =>
                                                        handleChangeFunctionSettingValue(
                                                            groupItem[0],
                                                            groupItem[1],
                                                            item[0]
                                                        )
                                                    }
                                                />
                                                <label
                                                    htmlFor={`switch-${groupItem[0]}-mode`}
                                                ></label>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    );
                }
            })}
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => window.location.reload()}
            />
        </>
    );
}

export default FunctionSetting;
